import React from 'react';
import SiteFooter from '../components/SiteFooter';

export default function TermsAndConditionsPage() {
  const paragraphs = [
  "Редакція від 13.02.2026",
  "1. Загальні положення",
  "1.1. Сервіс «Книгообіг» є онлайн-платформою для організації обміну паперовими книгами між користувачами.",
  "1.2. Послуги надаються фізичною особою-підприємцем (ФОП), зареєстрованим відповідно до законодавства України (3 група єдиного податку).",
  "1.3. Сервіс не є фінансовою установою та не надає фінансових послуг.",
  "1.4. Користування сервісом означає повний акцепт цих Умов.",
  "2. Предмет послуги",
  "2.1. Сервіс надає користувачам доступ до функціоналу платформи для обміну книгами.",
  "2.2. Оплата здійснюється за доступ до функціоналу сервісу.",
  "3. Правовий статус внутрішніх монет",
  "3.1. Монети є виключно внутрішньою обліковою одиницею сервісу.",
  "3.2. Монети не є грошима, електронними грошима, віртуальними активами або криптовалютою.",
  "3.3. Монети не є платіжним засобом та не можуть використовуватися поза межами сервісу.",
  "3.4. Монети не підлягають виведенню, обміну або конвертації в грошові кошти.",
  "3.5. Монети не мають інвестиційного характеру та не передбачають отримання доходу.",
  "4. Оплата",
  "4.1. Користувач здійснює оплату послуг у гривнях через підключеного платіжного провайдера.",
  "4.2. Платформа несе за собою право не прийняти книгу, якщо вона в поганому стані, старше 25 років, або написана російською мовою",
  "4.3. Сервіс не зберігає реквізити платіжних карток.",
  "4.4. Всі платежі є оплатою послуг, а не купівлею цифрової валюти.",
  "5. Обмеження відповідальності",
  "5.1. Сервіс не гарантує безперервної роботи.",
  "5.2. Адміністрація має право відмовити в проведенні операції у разі підозри на шахрайство."
  ];

  return (
    <div style={{ background: '#F6F4EF', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <main style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px', width: '100%', flex: 1 }}>
        <section
          style={{
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 14,
            padding: '20px 16px',
          }}
        >
          <h1 style={{ margin: '0 0 8px', color: '#0b5226' }}>УМОВИ ТА ПРАВИЛА КОРИСТУВАННЯ СЕРВІСОМ «КНИГООБІГ»</h1>
          {paragraphs.map((text, idx) => (
            <p
              key={idx}
              style={{
                margin: idx === paragraphs.length - 1 ? 0 : '0 0 10px',
                color: '#374151',
                lineHeight: 1.6,
              }}
            >
              {text}
            </p>
          ))}
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
